import React, { Fragment, useCallback, useEffect, useRef, useState } from "react";
import VPLIcon from "../Icons/VPLIcon";
import { CopyLink, FacebookIcon, PintrestIcon, ShareIcon, TwitterIcon } from "../Icons/SocialIcons";

import { UserContext } from "../Definitions/UserContext";
import OopsBanner, { NoRecordsBanner } from "../OopsBanner";
import { addtoCartEnum, utils } from "../../utils/Utils";
import { AsyncAjaxPost } from "../Utilities/AsyncAjaxService";
import Loader from "../Common/Loader";
import $ from "jquery";
import ReactDOM, { createPortal, unmountComponentAtNode } from "react-dom";
import VGPopUp from "../Controls/VGPopUp";
import Toast from "../Utilities/Toast";
import RenderBusinessCart from "./RenderBusinessCart";
import { DownCaret } from "../Icons/Carets";
import { ProductAccordion } from "./Product/ProductAccordian";
import ReactPlayer from "react-player";
import XIcon from "../Icons/XIcon";
import { ColorRelativeLumananceFromHex } from "../Utilities/ColorMath";
import { CategoryData } from "./RenderBusinessProducts";
import ProductLightBox, { ProductImageSlider } from "./Product/ProductLightBox";



type InventoryVariant = {
    mySiteInventoryId: string,

    barcodeId: string,
    productName: string,
    businessCost: number,
    sellingPrice: number,
    isTrackInventory: boolean,
    quantity: number,
    zeroQuantityVisibility: number,
    sellingPriceWithTax: number,
    vplStatus: number,
    type: number,
    isIncludeTaxInOnlinePricing: boolean,
    bundleQty: number,
    isOnlineProduct: boolean,
    combination:     {
        mySiteInventoryId: string,
        businessOptionVariantId: string
      }[],
}

type ImageData = {
    imageUrl: string,
    width: number,
    height: number,
    isDefault: boolean,
    imageOrder: number,
    cdnUrl: string,
    mySiteInventoryId: string
}

const imgFolder = "/Inventory/350x350/"
const imgFolderLrg = "/Inventory/800x0/"

const getCurrencySymbol = (userContext: UserContext) =>{
    let currency = "$";
    if(userContext.MultilocationData){
        let loc = userContext.MultilocationData.find((l:any)=>userContext.bidHash==l.encBIDHash);

        if(loc&&loc.currencySymbol){
            currency = loc.currencySymbol;
        }
    }

    return currency;

}


function UpdateDetailURL(inventoryId:string,businessId:string,isVariant:boolean=false){

    if(window.location.href.includes("localhost:3000"))
        return;
    let url = window.location.pathname;
    let isPreview = url.endsWith("/preview");
   
    let split = url.split("/").filter((s:string)=>s!=""&&s!="preview");

   if(split.length>3){ // remove bid and inventoryId
    split.pop();
    split.pop();
   }
   if(split[split.length-1]==("v")){ // remove the variant tag if present
    split.pop();
   }

   if(window.location.href.includes(utils.MySiteName())||window.location.origin.includes("localhost"))
        split.shift();//remove the mysite url

   url = split.join("/"); // reassemble full url without the ids and variant tag
 
   if(!url.endsWith("/"))
    url += "/";
   if(isVariant)
        url += "v/";

    url += businessId+"/"+inventoryId;
    if(isPreview)
        url += "/preview";





    window.history.replaceState(null, document.title, url);
}

export default function RenderProductDetails({ userContext, data }: { userContext: UserContext, data: any}) {

    const currency= getCurrencySymbol(userContext);
    const inventoryRootData= data?.inventory;
    const [categories,setCategories] = useState<CategoryData[]>([]);


    const AlertPopup = (message: string, title: string = "Out of Stock") => {
        const PopupClose = () => {
            let dom = document.getElementById("OpenDialog");
            if (dom) unmountComponentAtNode(dom);

        };

        return ReactDOM.render(
            <VGPopUp
                id={"total-quantity"}
                show={true}
                onHide={() => { PopupClose(); }}
                title={"Out of Stock"}
                dialogClassName="block-edit"
                body={
                    <div className="alertContent">
                        <p>{message}</p>
                    </div>
                }
                footer={
                    <Fragment>

                        {<button className={"v-button primary invisible-button"} onClick={(e) => { PopupClose(); }}>{"OK"}</button>}

                    </Fragment >
                }
                isRemoveTabModalIndex={false}
                isShowFooter={true}
                size={"modal-sm"}
                backdrop={true}
            />,
            document.getElementById("OpenDialog"));
    }

    // const [currentVariant, setCurrentVariant] = useState<InventoryVariant|null>(null);

    const setVariantAtIndex =( index:number,value:InventoryVariant)=>{


        let selected = [...selectedVariants];
        selected[index] = value;
        setSelectedVariants(selected);

    }


    const [numberOfVariantProducts, setNumberOfVariantProducts] = useState<number>(0);

    const [selectedVariants, setSelectedVariants] = useState<InventoryVariant[]>([]);

    const [lightBoxOpen,setLighBoxOpen] = useState(false);

    const startingVPL = "";//let update price handle starting vpl
    
    const [staticBundleProducts,setStaticBundleProducts] = useState<InventoryVariant[]>([]);

    const [images,setImgs] = useState<string[]>([]);


    const  [maxQty,setMaxQty] = useState(99999999999999);


    const [imageUrl, setImageUrl] = useState(data?.imagePath??" loading");

    const productName = inventoryRootData?.productName ?? "";
    const brandName = inventoryRootData?.brand ?? "";
    const vpl = useRef( startingVPL);
    const isVpl = data.vplStatus == 2;
    const [isLoading, setLoading] = useState(false);

    const productPrice =  useRef( currency + data.sellingPrice?.toFixed(2));
    const productDescription = inventoryRootData?.description ?? "";
    // const otherImages = images;
    const [playingVideo,setPlayingVideo] = React.useState("");
    const quantRef = useRef<HTMLInputElement>(null);
    const priceRef = useRef<HTMLSpanElement>(null);
    
    const lightBoxPortalRef = useRef<any>();


    const [variationOptions,setVariationOptions] = useState<ProductVariationData[]>([]);

    const [variants,setVariants] = useState<InventoryVariant[]>([]);

    const CreateBaseVariant = (isBundle:boolean,inData?:any)=>{

      if(!inData)
        inData = data;

        let variant:InventoryVariant = {
            mySiteInventoryId: "",
            barcodeId: "",
            productName: "",
            businessCost: 0,
            sellingPrice: 0,
            isTrackInventory: false,
            quantity: 0,
            zeroQuantityVisibility: 0,
            sellingPriceWithTax: 0,
            vplStatus: 0,
            type: 0,
            isIncludeTaxInOnlinePricing: false,
            bundleQty: 0,
            isOnlineProduct: false,
            combination: []
        }
        let combined = {...variant,...inData.inventory};
        if(isBundle){ // if it's a bundle just ignore most fields and leave empty to calc with bundle datas
            combined.isTrackInventory = false;
            combined.mySiteInventoryId = "";
            combined.sellingPrice = 0;
            combined.sellingPriceWithTax = 0;
        }

        if(combined.isIncludeTaxInOnlinePricing)
            combined.sellingPrice = combined.sellingPriceWithTax;
 

        return combined;

    }




    const findValidVariantFromOptions = ( options:ProductVariationData[],variants:InventoryVariant[],requireInStock:boolean = false,setSelected:boolean = false)=>{
        if(requireInStock)
            variants = variants.filter((v:InventoryVariant)=>v.quantity>0||!v.isTrackInventory);

        for(let v = 0;v<variants.length;v++){
            let variant = variants[v];
            let valid = true;
            let selections = [];
    
            

            for(let c = 0;c<variant.combination.length;c++){
                let id = variant.combination[c].businessOptionVariantId;
                let found = false;
                for(let o = 0;o<options.length;o++){
                    for(let oo = 0;oo<options[o].options.length;oo++){
                        if(options[o].options[oo].value == id){
                            selections.push({option:o,val:id});
                            found = true;
                            break;
                        }
                     
                    }
                    if(found)
                        break;
                }
                if(!found){
                    valid = false;

                    break;
                    
                }
            }

            if(valid) {
                if(setSelected){
                 

                    for(let i = 0;i<selections.length;i++){
                        options[selections[i].option].selected = selections[i].val;
                
                    }
                }

                return variant;

            }
        }

        return null;


    }




    const InitStateFromData = (inData?:any)=>{

        if(!inData)
            inData = data;

        if(inData.categorys){

            let cats = inData.categorys;

            let ordered = [];
            let root:CategoryData = cats.find((c:any)=>c.parentCategoryId==null||c.parentCategoryId=="");

            while(root){
                ordered.push(root);
                root = cats.find((c:any)=>c.parentCategoryId==root.id);

            }

            setCategories(ordered);
        }



        const options = inData?.inventoryOptions??[];
    
/*
1 = Chips
2 = Dropdown
3 = image
4 = colors
*/

        //map variation options to mysite data
        const variantOptions =  options.map((optn:any)=>{

            let type = ProductVariationType.Chips;
            switch(optn.displayAs){
                case 1: // updating again!
                    type = ProductVariationType.Chips;
                    break;
                case 2:
                    type = ProductVariationType.Dropdown;
                    break;                
                case 4:
                    type = ProductVariationType.Colors;
                    break;
                case 5:
                    type = ProductVariationType.Images;
                    break;
            }


            let variants = optn.vanriants??[];

            return {
                label:optn.name,
                inventoryMasterName:optn.inventoryMasterName,
                selected:"",
                options: variants.map((v:any)=>{
                    return {
                        inventoryMasterName:v.inventoryMasterName,
                        varIndex:0,
                        label:(v.colorCode&&type==ProductVariationType.Colors ? v.colorCode:  v.variantName),
                        value:v.id,
                        soldOut:false,
                        image: type ==  ProductVariationType.Images ? v.imagePath : "",
                        variantName: v.variantName                        
                    }
                }),
                type:type
            }
            
        });
        
        let prevNames:string[] = [];
        let index = -1;

        //index each variation if it targets a different product
        variantOptions.forEach((v:ProductVariationData)=>{
            let name = v.inventoryMasterName;
            v.varIndex = index;
            if(!prevNames.includes(name)){
                prevNames.push(name);
                index++;
                v.varIndex = index;
            }

        })

        let numOfVar = index + 1;
        let newSelection:InventoryVariant[] = [];
        if(numOfVar == 0 && !isStenciled){
          let isBundle = inData.bundleProductWithoutVariants&&inData.bundleProductWithoutVariants.length>0;

          newSelection = [CreateBaseVariant(isBundle, inData)];
        }
        else{
        //set the total number of products
            setNumberOfVariantProducts(numOfVar);
         }
        const productVariants = (inData.variants??[]).map((v:any)=>{

            if(v.isIncludeTaxInOnlinePricing)
                v.sellingPrice = v.sellingPriceWithTax;
            return v;

        });

  

        let instock = productVariants.filter((v:InventoryVariant)=>(!v.isTrackInventory||v.quantity>0));

   
        //for each product (normally just one)
        for(let i =0;i<numOfVar;i++){
            
            //get the options for this specifc product
            let optns:ProductVariationData[] = variantOptions.filter((v:ProductVariationData)=>v.varIndex==i);

            let variant = findValidVariantFromOptions(optns,instock,false,true);        //for each item that is in stock
            if(variant){

                newSelection.push(variant);
            }
            else{
                newSelection.push({
                    mySiteInventoryId: "",
                
                    barcodeId: "",
                    productName: "",
                    businessCost: 0,
                    sellingPrice: 0,
                    isTrackInventory: false,
                    quantity: 0,
                    zeroQuantityVisibility: 0,
                    sellingPriceWithTax: 0,
                    vplStatus: 0,
                    type: 0,
                    isIncludeTaxInOnlinePricing: true,
                    bundleQty: 0,
                    isOnlineProduct: false,
                    combination:[],
                });
            }

        }

        let selected = newSelection as InventoryVariant[];
   
        setSelectedVariants(selected);
        let bundleVariants = [];
        if(inData.bundleProductWithoutVariants){
            bundleVariants=inData.bundleProductWithoutVariants;
        }

        let allProducts = [...bundleVariants,...selected];

        bundleVariants = bundleVariants.map((v:InventoryVariant)=>{
            if(v.isIncludeTaxInOnlinePricing)
                v.sellingPrice = v.sellingPriceWithTax;
            return v;

        })
        setStaticBundleProducts(bundleVariants);
        let max = 999999999999;
        allProducts.forEach((v:InventoryVariant)=>{
            if(v.isTrackInventory && v.quantity<max){
                max = v.quantity;
            }
        })

        setMaxQty(max);

     
        const imgs:string[] =[];

        if(data.images){
            data.images.forEach((img:any)=>{

                if(img?.mySiteInventoryId==data?.inventory?.mySiteInventoryId){
                 

                    if(img?.cdnUrl){
                        imgs.push(img?.cdnUrl+imgFolderLrg+img?.imageUrl);
                    }
                    else if(typeof img == "string"){
                        imgs.push(img);
                    }
                }
            })
        }

  
        setImageUrl(imgs[0]);
        setImgs(imgs);

        //setVariationData(newVariants);
      SetOutOfStockOptions(variantOptions);

        // if(currentVar)
        // setCurrentVariant(currentVar);
        setVariants(productVariants);


    }

    const SetOutOfStockOptions = (vData?:ProductVariationData[],numOfProducts = -1)=>{

        if(!vData)
            vData = [...variationOptions];

        if(numOfProducts<1)
            numOfProducts = numberOfVariantProducts;
        if(numOfProducts <1)
            numOfProducts = 1




    for(let i = 0;i<numOfProducts;i++){

        let filterdData = vData.filter((v:any)=>v.varIndex==i);
        const selections = filterdData.map((v:any)=>v.selected);
        //check each permutation
        for(let i = 0;i<filterdData.length;i++){
           
            for(let o = 0;o<filterdData[i].options.length;o++){

                let val = filterdData[i].options[o].value;
                let testSelection = [...selections];
                testSelection[i] = val;
                let found = false;
                for(let v of variants){

                    let match = true;

                    for(let j = 0;j<v.combination.length;j++){

                        let id = v.combination[j].businessOptionVariantId;
                        if(!testSelection.includes(id)){
                            match = false;
                            break;
                        }

                    }

                    if(match &&(v.quantity>0||!v.isTrackInventory) ){ // only counts if variation is actually in stock or not tracking inventory
                        found = true;
                        break;
                    }
                }
                filterdData[i].options[o].soldOut = !found;
        
            }
        }
    }
        vData.sort((a,b)=>b.varIndex-a.varIndex);
        setVariationOptions([...vData]);
    }

    const UpdateSelectedVariantFromData = (vData?:ProductVariationData[],index:number = -1)=>{
        if(!vData)
            vData = [...variationOptions];

        if(index>=0){
            vData = vData.filter((v:any)=>v.varIndex==index);
        }
        const selections = vData.map((v:any)=>v.selected);

        for(let v of variants){
            let match = true;
            for(let j = 0;j<v.combination.length;j++){
                if(!selections.includes(v.combination[j].businessOptionVariantId)){
                    match = false;
                    break;
                }
            }

            if(match){
                //setCurrentVariant(v);
                if(index>=0){
                    setVariantAtIndex(index,v);
                    return;
                }
                break;
            }
        }


    }

    const quantity = useRef(1);//leave as one for useeffect trigger..

    const isEditor = ((window as any).isEditor == true)

    const isStenciled = data?.isStenciled;

    const setQuantity = (quant: number) => {


        updateProductPrice(quant);
        quantity.current = quant;
    }

    useEffect(() => { 
      
   
        if(!isStenciled)
        document.title = productName;

        //update product price when data updates
        productPrice.current = (data.currencySymbol ?? "$") + (data.sellingPrice)?.toFixed(2);
          // set to 0 if not in stock
        if(maxQty<=0&&quantity.current>0){
            updateProductPrice(0);
            if(quantRef.current){
                quantRef.current.value = "0";
            }
        }

        if(maxQty<0){
            AlertPopup("This product is out of stock based on the quantity you have selected","Out of Stock");
        }

        // if(currentVariant==null&&data.variations&&data.variations.length>0){
        //     setCurrentVariant(data.variants[0]);
        // }

    }, [data])

    //Variant change
    useEffect(()=>{
     
        SetOutOfStockOptions();
        updateProductPrice(quantity.current);

        for(let i = 0;i<selectedVariants.length;i++){
            if(selectedVariants[i].quantity<quantity.current && selectedVariants[i].isTrackInventory){
                setQuantity(selectedVariants[i].quantity);
            }

        }



        if((maxQty<quantity.current)){
        
            AlertPopup("There are only "+maxQty+" ("+productName+") left in stock, quantity has been updated","Out of Stock");
            setQuantity(maxQty);
        }
        if(numberOfVariantProducts==1){
            let currentVariant = selectedVariants[0];

                    if(currentVariant&&data&&data.images){

                        let validImages = data.images.filter((img:ImageData)=>img.mySiteInventoryId==currentVariant.mySiteInventoryId);
                        if(validImages.length == 0)
                            validImages = data.images.filter((img:ImageData)=>img.mySiteInventoryId=="");
                    
                        let urls = validImages.map((img:ImageData)=>img.cdnUrl+imgFolderLrg+img.imageUrl);
                 
                    
                            setImgs(urls);

                           // if(!urls.includes(imageUrl)){
                                setImageUrl(urls[0]??"");
                           // }
                    
                    } 

                    if(currentVariant && !isStenciled){
                        let isVariant = (currentVariant?.mySiteInventoryId != data.inventory.mySiteInventoryMasterId);
                        UpdateDetailURL(currentVariant.mySiteInventoryId,userContext.businessId,isVariant);
            
                        if(data?.inventory?.productName){
                          
                            document.title = productName + (numberOfVariantProducts==1?" - "+currentVariant.productName:"");
                        }
                    }
    
    
    }
    
   
    let allProducts = [...staticBundleProducts,...selectedVariants];

    let max = 999999999999;
    allProducts.forEach((v:InventoryVariant)=>{
        if(v.isTrackInventory && v.quantity<max){
            max = v.quantity;
        }
    })
    setMaxQty(max);

    },[selectedVariants])

    useEffect(()=>{

        if(data && !data.isStenciled){
            InitStateFromData(data);
        }

    },[data])

    const updateProductPrice = (qnty: number) => {


        let clampedQnty = Math.max(1, qnty);
     
        let addedPrice = 0;
   
        for(let i = 0;i<staticBundleProducts.length;i++){
            addedPrice += staticBundleProducts[i].sellingPrice;
        }

        for(let i = 0;i<selectedVariants.length;i++){
            addedPrice +=selectedVariants[i].sellingPrice;
        }

        


       



        const totalSellingPrice = addedPrice * clampedQnty;
       // (variant?.sellingPrice??0) * qnty;

        productPrice.current = (currency) + (totalSellingPrice)?.toFixed(2);
        if (priceRef.current) {
            priceRef.current.innerText = productPrice.current;
        }

        if(isVpl){
            let dom = document.getElementById("vpl-message");
            if(dom&&dom.parentElement){
                if(qnty==0){
                    dom.parentElement.style.display="none";       
                }
                else{
                    dom.parentElement.style.display="block";
                }
            }

            const vplPrice = (totalSellingPrice/4).toFixed(2);
            vpl.current = "or 4 payments of "+(currency)+vplPrice+" with "; 
           
            if(dom)
                dom.innerText = vpl.current;
         
        }
    }

    const ProductImage = useCallback(() => {

        let url = imageUrl?`url(${imageUrl})`:`url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='rgb(150,150,150)' viewBox='0 0 512 512'%3E%3C!--!Font Awesome Pro 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc.--%3E%3Cpath d='M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'/%3E%3C/svg%3E")`
        const mainStyle:any =  {paddingBottom:"125%",borderRadius:"8px",overflow:"hidden",cursor:"zoom-in"}
        if(!imageUrl){
            mainStyle.backgroundSize = "cover";
            mainStyle.backgroundPosition = "center";
            mainStyle.backgroundImage = url;
        }
        return (
            <div className="w-full flex-column full-width-mobile product-details-image-section"  style={{  width: "50%", maxWidth: "544px",minWidth:"300px" }}>
        
                {/* <div className="w-full stencil-item " 
             
                style={{backgroundColor:"#ffffff65", paddingBottom: "125%",borderRadius:"8px", backgroundSize: "cover",cursor:"pointer", backgroundPosition: "center", backgroundImage: url, outline: "1px solid rgba(0,0,0,.1)" }}>
                    
                </div> */}
                <div className="w-full stencil-item relative "
                    style={mainStyle}
             
                >
                   {imageUrl&& <ProductImageSlider  overrideZoom={ ()=> setLighBoxOpen(true)} onPickImage={(urL:string)=>{
                    setTimeout(()=>{setImageUrl(urL)},300); // wait for transitioning to end
                   }} allImages={images} url={imageUrl}  imgStyle={{width:"100%",height:"100%",objectFit:"cover",objectPosition:"center"}} includeArrows={false} includeDots={false} />}

                </div>
                <div className="w-full  justify-start   image-select-card-row" id="product-details-other-images" style={{ marginTop: "16px" }}>
                    {images.length> 1 &&images.map((largeImage, index) => {

                        let image = largeImage.replace(imgFolderLrg,imgFolder);
         
                        let marginRight = ((index+1) % 4==0)?"0px":"16px";
                        let isvid = isVideo(image);

                    

                        let isSelected = (largeImage == imageUrl);

                        return <div className={"center-all image-select-card "+(isSelected?"selected":"")}
                            onClick={() => {
                                
                                if(isvid){
                                    setPlayingVideo(image);
                                }
                                else{
                                setImageUrl(largeImage)
                                }

                            }}
                            key={image + index} style={{marginRight:marginRight, width: "calc(25% - 12px)", backgroundImage: `url(${image})`  }}>
                                {/* {isvid&&
                                <div className="center-all" style={{position:"absolute",width:"100%",height:"100%",left:0,top:0}}>
                                <div className="center-all" style={{paddingLeft:"5%", width:"60%",height:"60%",borderRadius:"100px",border:"2px solid #777"}}><svg xmlns="http://www.w3.org/2000/svg" fill="#333" height={"50%"} viewBox="0 0 384 512"> <path d="M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80L0 432c0 17.4 9.4 33.4 24.5 41.9s33.7 8.1 48.5-.9L361 297c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41L73 39z"/></svg></div>
                                </div>
                                } */}

                            </div>

                    })}
                </div>
        </div>)

    },[data,imageUrl,playingVideo,categories,images])
    const QuantityField = useCallback(() => {

        return <div className="flex-row justify-between align-center "
            style={{ margin: "8px 0px 8px 0px" }}
        ><div className="flex-row" >

                <input className="no-arrow-num text-align-center" style={{borderRadius:"3px 0 0 3px", width: "50px", height: "40px", outline: "1px solid #aaa", border: "none",paddingRight:"6px"}} type="number" defaultValue={quantity.current} ref={quantRef} onChange={(e) => {

                    let target = e.target as HTMLInputElement;

                    if (e.target) {

                        let val = target.value.replace(/\D/g, '').replaceAll(".","").trim();

                        if (val == "")
                            val = "0";

                        let qInt = parseInt(val);
                        if (qInt > maxQty) {
                            AlertPopup("This product is out of stock based on the quantity you have selected");
                            qInt = maxQty;
                        }
                        if (qInt <= 0)
                            qInt = 1

                        if (quantRef.current)
                            quantRef.current.value = qInt.toString();
                        setQuantity(qInt)

                        target.value = qInt.toString();

                    }
                }} />
                <button
                    style={{ width: "40px", height: "40px", background: "#eee", outline: "1px solid #aaa", color: "#666" }}
                    className="price-btn invisible-button center-all font-large font-bold"
                    onClick={() => {

                        if (quantity.current > 1) {
                            setQuantity(quantity.current - 1);
                            if (quantRef.current) {
                                quantRef.current.value = (quantity.current).toString();
                            }

                        }

                    }}
                >
                <svg xmlns="http://www.w3.org/2000/svg" height=".6em" fill="#333" viewBox="0 0 448 512" style={{position:"absolute"}}><path d="M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z"/></svg>                </button>
                <button

                    style={{ width: "40px",borderRadius:"0 3px 3px 0", height: "40px", background: "#eee", outline: "1px solid #aaa", color: "#666" }}
                    className="invisible-button center-all font-large font-bold price-btn"
                    onClick={() => {

                        if (quantity.current < maxQty) {
                            setQuantity(quantity.current + 1);
                            if (quantRef.current) {
                                quantRef.current.value = (quantity.current).toString();
                            }
                        }
                        else {
                            AlertPopup("This product is out of stock based on the quantity you have selected"); 
                        }
                    }}
                >

                <svg xmlns="http://www.w3.org/2000/svg" height=".6em" fill="#333"viewBox="0 0 448 512" style={{position:"absolute"}}><path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z"/></svg>
                </button>

            </div>
        </div>
    },[data,quantity.current,selectedVariants,maxQty])


    const Details = useCallback(() => {
        return <>
            <div className="flex-row align-start justify-between stencil-item  row-gap-large relative"
            style={{marginBottom:"0px"}}
            ><h1 className="full-width-mobile" style={{wordBreak:"break-word",fontSize:"32px",minWidth:"250px"}}>{productName} </h1> <ShareDropDown extraClass="" copyMessage="Product Link Copied To Clipboard" shareURL={window.location.href} shareTitle={productName} /></div>
            <span className="stencil-item">{brandName} </span>
      
            <p className="vp-1 stencil-item" style={{ textAlign: "left", marginTop: "8px", wordBreak: "break-word" }}>
                {productDescription}
            </p>
            {/*product price*/}
            <div className="flex-column col-gap-med stencil-item max-content" ><span ref={priceRef} className="font-bold font-large">{productPrice.current} </span>
                {isVpl && <span style={{ fontSize: "13px" }}  ><span id="vpl-message">{vpl.current}</span> <VPLIcon /></span>}
            </div>

            {data?.bundleInfo?.includedItems&&data.bundleInfo.includedItems.length>0 &&
                <ul style={{ marginLeft: "-.75em" }}>
                {
                    data.bundleInfo.includedItems.map((item:string,index:number)=>{
                        return <li key={index}>{item}</li>
                    })
                }
            </ul>
      
            }
   
            {variationOptions.map((variation,index)=>{

                let onChange = (value:string)=>{
                    let data = [...variationOptions];
                    data[index].selected = value;
                    SetOutOfStockOptions(data);

                    UpdateSelectedVariantFromData(data,variation.varIndex);
                    
                
                   
                }

                let title = "";
                if(
                 numberOfVariantProducts>1 &&    (index == 0||variationOptions[index-1].inventoryMasterName!=variation.inventoryMasterName) 
                ){
                    title = variation.inventoryMasterName;
                }
         

                switch(variation.type){
                    case ProductVariationType.Chips:
                        return <><ProductModuleChips title={title} key={variation.label+index} {...variation} onChange={onChange}  /></>
                    case ProductVariationType.Colors:
                        return  <><ProductModuleColors  title={title} key={variation.label+index} {...variation} onChange={onChange}/></>
                    case ProductVariationType.Images:
                        return <><ProductModuleImgs title={title} key={variation.label+index} {...variation} onChange={onChange} /></>
                    case ProductVariationType.Dropdown:
                        return <><ProductModuleDropdown title={title} key={variation.label+index} {...variation} onChange={onChange} /></>


                }

                return null;


            })

            }


            {staticBundleProducts.length>0&&<br/>}
            {staticBundleProducts.map((variant,index)=>{

                return <h3 key={index} style={{wordBreak:"break-word",minWidth:"250px"}}>{variant.productName} </h3>
  
            })
            }
            <div></div>
            <div className="flex-row-to-column">
            {isStenciled ?
                <div className="stencil-item w-full" style={{ height: "40px", marginBottom: "8px",marginTop:"8px"}}></div>
                :
                <QuantityField />
            }
            <div style={{width:"16px"}}></div>
            <button id="productaddcart" className="v-button primary w-full invisible-button " style={{ marginBottom: "8px",marginTop:"8px",height:"40px" }}
                onClick={(e) =>{ 
                    
                    let listA = staticBundleProducts.map((v:InventoryVariant)=>v.mySiteInventoryId);
                    listA = [...listA,...selectedVariants.map((v:InventoryVariant)=>v.mySiteInventoryId)];
                    listA = listA.filter((v:string)=>v!="");
                    let reqIds = listA.join(",");
                    
                    ProductAddToCart(e.currentTarget.id,userContext.businessId,data?.inventory?.mySiteInventoryId??"",reqIds)
                }}
            >Add to Cart</button></div>
            <br/>
            <br/>
          
            </>
    },[data,productDescription,productName,productPrice.current,vpl.current,selectedVariants,staticBundleProducts])


    const FAQs = useCallback(() => {
        return <>
                    <style>
                {`
                .product-details-info tr{
                   
                    background:transparent;
                    color:var(--default-font-color);
                }

                .product-details-info .accordion-content p,
                .product-details-info .accordion-content ul,
                .product-details-info .accordion-content ol
                {
                    margin-bottom:1em !important;
                }

                .product-details-info figure.table{
                    width:100%;
                    overflow:auto;
                    
                }
                
                .product-details-info table{
                    width:100%;
                    border-radius:4px;
                }

                .product-details-info tr{
                    border:1px solid var(--theme-color-3);
                 
                }
                .product-details-info tr:nth-child(odd){
                background:var(--theme-color-6);
                }
                .product-details-info thead tr{
                    border:none;
                    background:transparent !important;
                }

                .product-details-info th{
              
                   padding:.5em 1em;

                }

                .product-details-info td{
                    padding:.5em 1em;
                    background:transparent;
             
                }

         
                `
                }
            </style>
            <div className='product-details-info'>
           {data.additionalDetails&&
           data.additionalDetails.map((detail:any,index:number)=>{

            let desc = detail.detailDescription??"";

            //make all links open in a new tab
            desc = desc.replaceAll("<a href","<a target='_blank' href");
            //remove duplicate from api response
            desc = desc.replaceAll("https://https://","https://");

             return  <ProductAccordion useAsHTML={true} key={index} label={detail.detailTitle} content={desc} />

           })


           }
          </div>
        </>

    },[data])

    const ProductAddToCart = async (event: any,inBid?:string,inId?:string,inIdList?:string) => {

        if (isEditor || quantity.current <= 0)
            return;


        let LoginDetails = utils.ReadCookie();
        if (LoginDetails.EncUid === undefined || LoginDetails.EncUid === "" || LoginDetails.EncUid === null) {
            window.wbc.openVagaroPage("divVagaroIframe", utils.VURL("Login", null) + addtoCartEnum.ProductAddToCart + "&Data="+event);
            $(".modal-backdrop").hide();
            $(".vgn-popup").hide();
            return;
        }
        else {
            let businessId ="";
            let itemId = "";

            if(!inId || !inBid){
                let url = window.location.pathname;
                let split = url.split("/");
                if (split[split.length - 1] == "") {
                    split.pop();
                }
                if (split[split.length - 2] != "") {
                    businessId = split[split.length - 2];
                }
                if (split[split.length - 1] != "") {
                    itemId = split[split.length - 1];
                }
            }
            else if(inId){
                itemId = inId;
            }
            else if(inBid){
                businessId = inBid;
            }
            if(!businessId||businessId=="")
                businessId = userContext.businessId;
            // let str = split.pop();
            // if (str && str.length > 1) {
            //     let numberSplit = str.split(/-(.*)/s);
            //     if (numberSplit.length >= 2) {
            //         businessId = numberSplit[0];
            //         itemId = numberSplit[1];
            //     }
            // }
            setLoading(true);
            const Requestdata: any = {};
            Requestdata.encinventoryID =  itemId; //itemId;
            Requestdata.quantity = quantity.current;
            Requestdata.totalQuantity = maxQty;
            Requestdata.isFromPoupup = 1;
            Requestdata.EncUid = LoginDetails.EncUid;
            Requestdata.siteEncBid = userContext.sitebid;
            Requestdata.InventoryIds = inIdList??"";
            await AsyncAjaxPost(
                businessId + "/addtocart/addtocart",
                Requestdata,
                userContext.accessToken,
                function onSuccess(data: any) {
                    //handlepopupClose();
                    setLoading(false);

                    var cartReuslt = data.data.data;


                    if (cartReuslt || cartReuslt === 0) {                        
                        let doms = document.getElementById("divcart");
                        if (doms) unmountComponentAtNode(doms);
                        ReactDOM.render(<RenderBusinessCart data={cartReuslt} userContext={userContext}/>, document.getElementById("divcart"));
                        Toast("Item added to cart");
                    }

                },
                function onError(data: any) {

                    setLoading(false);
                    AlertPopup("Oops,something went wrong. please try again later", "Error");
                }
            )

        }
    }



    if (!data) {
        return <OopsBanner />
    }
    else if( data.noRecordsFound){
        return <div className="center-all flex-column col-gap-large" style={{minWidth:"340px",minHeight:"400px"}}>
      <div>The Product you are looking for is either out of stock or does not exist.</div>
        <br></br>
        <a className="v-button primary invisible-button "    
            href="./"
               
            >Go Back Home</a>
    </div>
    }
    else if(!data.inventory&&!isStenciled){

      

    return <div className="center-all flex-column col-gap-large" style={{minWidth:"340px",minHeight:"400px"}}>
        <NoRecordsBanner message="Product Not Found" showInLive={true}/>
        <br></br>
        <a className="v-button primary w-full invisible-button "    
            href="./"
               
            >Go Back Home</a>
    </div>
}



    return (
        <>
        <div ref={lightBoxPortalRef}></div>
        <div className={"flex-column align-center "+ (isStenciled ? "stenciled" : "")}>
   
        <div className="flex-row justify-start align-start flex-wrap row-gap-med w-full" style={{padding:"24px",marginBottom:"40px",maxWidth:"1112px"}}>
                    <DetailsBreadCrumbs orderedCats={categories}/>

                 </div>
          {playingVideo!=""&&lightBoxPortalRef.current&&<VideoLightbox portal={lightBoxPortalRef.current} url={playingVideo} onClose={()=>setPlayingVideo("")}/>}
          {lightBoxOpen&&lightBoxPortalRef.current&&<ProductLightBox
          onPickImage={(url:string)=>setImageUrl(url)}
          allImages={images}
          portal={lightBoxPortalRef.current} url={imageUrl} onClose={()=>setLighBoxOpen(false)}/>}
            <div className={"w-full flex-row justify-center align-start flex-wrap block-edit " } id="product-details-split">
                <ProductImage />
                <div className="w-full flex-column col-gap-med full-width-mobile" style={{ padding: "0 32px 32px 32px", width: "50%" }}>
                <Details />
                <FAQs/>
                </div>
        
            </div>
            <br></br>
            <br></br>

            {isLoading && <Loader />}
            </div>
        </>

    )

}

export function GetItemBundleInfoFromData(data:any){

    let maxQuantity = 999999999;
    let includedItems:string [] = []
    for(let i = 0;i<data.length;i++){
        let item = data[i];

        if(item.isTrackInventory&&item.totalQty<maxQuantity){
            maxQuantity = item.totalQty;
        }

       let desc=item.name;
        if(item.bundleQty>1)
            desc+=` x ${item.bundleQty} Qty`;

        includedItems.push(desc);
    }

    return {
        maxQuantity:maxQuantity,
        includedItems:includedItems,
    }

}


enum ProductVariationType{
    Chips,
    Images,
    Dropdown,
    Colors,
}

type ProductVariationRoot = {
    inventoryMasterName:string,
    label:string
    selected:string,
    options:{label:string,value:string,soldOut:boolean,image:string,variantName:string}[],
}

type ProductVariationData = ProductVariationRoot&{varIndex:number,type:ProductVariationType};
type ProductModuleProps = ProductVariationRoot&{title?:string,onChange:(value:string)=>void}


function SoldOutText(){

    const clr = "#ffffffcc"
    const size = ".08em";
 
    return <span style={{fontSize:"12px",fontFamily:"proxima-nova",fontWeight:"bold",color:"#333355",lineHeight:"12px",textShadow:` ${size} 0 ${clr}, 0 0.07em ${clr}, -${size} 0 ${clr}, 0 -${size} ${clr}`}}>Sold Out</span>
}


function SoldOutTextAuto({color}:{color:string}){

    const luminance = ColorRelativeLumananceFromHex(color);
  
    if(isNaN(luminance))
        return <SoldOutText/>

    const clr =  luminance<.4?"#ffffffdd":"#000000dd";
    return <span style={{fontSize:"12px",fontFamily:"proxima-nova",fontWeight:"bold",color:clr,lineHeight:"12px"}}>Sold Out</span>
}

function useLightColorForContract(compareColor:string){
    const luminance = ColorRelativeLumananceFromHex(compareColor);
    if(isNaN(luminance))
        return false;
    return luminance<.4
}

function SelectedMark({checkForLumananceColor}:{checkForLumananceColor?:string}){


    let  circleColor = "#00000066";
   
       let checkColor = "#ffffff";

       if(checkForLumananceColor){
        circleColor = "#00000000";
              //if(!useLightColorForContract(checkForLumananceColor)){             
              // checkColor = "#000000";
              //}
       }


    return <svg xmlns="http://www.w3.org/2000/svg" height={"2em"} viewBox="0 0 512 512"><path className="fa-secondary" fill={circleColor} opacity=".4" d="M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm136 0c0-6.1 2.3-12.3 7-17c9.4-9.4 24.6-9.4 33.9 0l47 47c37-37 74-74 111-111c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7c2.3 2.3 4.1 5 5.3 7.9c.6 1.5 1 2.9 1.3 4.4c.2 1.1 .3 2.2 .3 2.2c.1 1.2 .1 1.2 .1 2.5c-.1 1.5-.1 1.9-.1 2.3c-.1 .7-.2 1.5-.3 2.2c-.3 1.5-.7 3-1.3 4.4c-1.2 2.9-2.9 5.6-5.3 7.9c-42.7 42.7-85.3 85.3-128 128c-4.7 4.7-10.8 7-17 7s-12.3-2.3-17-7c-21.3-21.3-42.7-42.7-64-64c-4.7-4.7-7-10.8-7-17z"/><path fill={checkColor} d="M369 175c9.4 9.4 9.4 24.6 0 33.9L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0z"/></svg>
}


const moduleStyling = {
    margin:"12px 0px"
}
const titleStyling = {marginBottom:"8px"};

export function ProductModuleChips({title,label,selected,options,onChange}:ProductModuleProps){

    return <div style={moduleStyling}>
   {title!=""&&<h3 style={titleStyling}>{title}<br/></h3>}
   
   <label  >{label}:</label>
    <div className="flex-row w-full row-gap-med flex-wrap"> 
            {
                options.map((option,index)=>{


                    let style:any = {
                        borderRadius:"3px",
                        border:"1px solid var(--theme-color-3)",
                        padding:"8px",
                        marginTop:"8px",
                        minWidth:"48px",
                        cursor:"pointer",
                        background:"var(--default-bg-color)",
                        color:"var(--default-font-color)",
                    }

                    if(option.soldOut){
                        style.opacity = ".5";
                        style.border = "1px dashed var(--theme-color-3)";
                        style.cursor = "not-allowed";
                    }

                    else if(option.value==selected){

                        style.background = "var(--theme-color-4)";
                        style.color = "var(--theme-color-0)";
                        style.border = "1px solid var(--theme-color-2)";
                     

                    }

                    return <button key={option.value + index} style={style} className={"invisible-button white-bg " + (option.value==selected||option.soldOut?"":"gray-hover")}  onClick={()=>{!option.soldOut&&onChange(option.value)}} >{option.label}</button>

                })
            }


            </div></div>

}
export function ProductModuleColors({title,label,selected,options,onChange}:ProductModuleProps){
    let selectedvariant:any = options.filter(
        (col) => col.value === selected
    );

    return <div style={moduleStyling}>
          {title&&<h3  style={titleStyling}>{title}</h3>}
    <label>{label}: {selectedvariant.length > 0 ? selectedvariant[0].variantName : ""}</label>
     <div className="flex-row row-gap-med flex-wrap"> 
    {
        options.map((option,index)=>{

            let style  = {
                width:"40px",
                height:"40px",
                borderRadius:"50%",
                background:option.label,
                border:"1px solid #cdcdcd",
                fontSize:"12px",
                outline:"",
                marginTop:"8px",
                cursor:"pointer",
        

            }
            if(option.soldOut){
                style.border = "1px dashed #cdcdcd";
                style.cursor = "not-allowed";
            }


            if(option.value==selected){
               
                style.outline = "2px solid #333";
            }

            return <button key={option.value + index} style={style} className="invisible-button center-all" onClick={()=>{!option.soldOut&&onChange(option.value)}}>
                {option.soldOut &&<SoldOutTextAuto color={option.label}/>}
                {option.value==selected &&<SelectedMark checkForLumananceColor={option.label}/>}
            </button>


        })
    }
            </div></div>
}

export function ProductModuleImgs({title,label,selected,options,onChange}:ProductModuleProps){
    let selectedvariant:any = options.filter(
        (col) => col.value === selected
    );

    return <div style={moduleStyling}>
             {title&&<h3  style={titleStyling}>{title}</h3>}
            <label>{label}: {selectedvariant.length > 0 ? selectedvariant[0].variantName : ""}</label><div className="flex-row row-gap-med flex-wrap"> 
            {
                options.map((option,index)=>{

                    let style  = {
                        width:"48px",
                        height:"48px",
                        borderRadius:"8px",
                        backgroundImage: `url(${option.image})`,
                        border:"1px solid #cdcdcd",
                        fontSize:"12px",
                        boxShadow:"",
                        backgroundSize:"cover",
                        cursor:"pointer",
                        outline:"",
                        marginTop:"8px",

                    }
                    if(option.soldOut){
                        style.border = "1px dashed #cdcdcd";
                        style.boxShadow = "inset 0px 0px 0px 100px #ffffff99";
                        style.cursor = "not-allowed";
                    }


                    if(option.value==selected){
                        style.border = "1px solid var(--theme-color-1)";
                        style.fontSize = "15px";
                        style.outline = "1px solid white";
                    }

                    return <button key={option.value+index} style={style} className="invisible-button center-all" onClick={()=>{!option.soldOut&&onChange(option.value)}}>
                        {option.soldOut &&<SoldOutText/>}
                        {option.value==selected &&<SelectedMark/>}
                    </button>


                })
            }
            </div>
            </div>
}

export function ProductModuleDropdown({title,label,selected,options,onChange}:ProductModuleProps){
    
    let selectedLabel = options.find((option)=>option.value==selected)?.label??"Sold Out";
    const [isOpen, setIsOpen] = useState(false);
    const domRef = useRef<HTMLDivElement>(null);

    const clickOutside = (e: any) => {

        if (isOpen&&domRef.current && !domRef.current.contains(e.target)) {
            setIsOpen(false);
        }


    }

    useEffect(() => {

        document.addEventListener("mousedown", clickOutside);
        return () => {
            document.removeEventListener("mousedown", clickOutside);
        }

    })

    return <div style={moduleStyling}>  
     {title&&<h3>{title}</h3>}
      <label>{label}:</label>
        <div className="w-full relative" style={{maxWidth:"320px",marginTop:"8px"}} ref={domRef}>
        <div onClick={()=>setIsOpen(true)}  className="flex-row w-full justify-between" style={{background:"white",color:"#333",border:"1px solid #cdcdcd",padding:"10px 8px",borderRadius:"3px",cursor:"pointer"}}>
            {selectedLabel}
            <DownCaret/>
        </div>
        {isOpen&&
        <div  style={{position:"absolute",width:"100%",background:"white",color:"#333",borderRadius:"4px",padding:"4px 0px",
            boxShadow:"0px 2px 10px 0px rgba(0,0,0,.1)",zIndex:5
        }}>
            {
                options.map((option,index)=>{
                    return <div key={option.value +index}  className={"invisible-button w-full gray-hover flex-row "+(selected==option.value?"selected":"")} style={{ pointerEvents:(option.soldOut?"none":"all"), textAlign:"left",padding:"10px 8px",fontSize:"15px",lineHeight:"20px",color:(option.soldOut?"#bbb":"#333")}} onClick={()=>{!option.soldOut&&onChange(option.value);setIsOpen(false)}}>{option.label} 
                    {option.soldOut && <div style={{marginLeft:"1em",borderRadius:"4px",background:"#00000022",padding:".4em",color:"#666"}} >Sold Out</div>}
                    </div>
                })
            }       
        </div>
        }

        </div>
     </div>
           
}

const isVideo = (url:string)=>{


    return url.includes(".mp4")||url.includes(".webm")||url.includes(".ogg")||url.includes("vimeo");
}

function VideoLightbox({portal,url,onClose }:{portal:HTMLElement,url:string,onClose:()=>void}){


    return createPortal(
    <div className="center-all no-delay vanimation-fade-in"

     onClick={onClose}
    style={{position:"fixed",left:0,top:0,width:"100%",height:"100%",background:"#000000ee",zIndex:3000}}>

        
        <ReactPlayer playing={true}  url={url} controls={true} width="80%" height="80%" />

        <button onClick={onClose} className="invisible-button" style={{color:"white",position:"absolute",top:"8px",right:"8px"}}><XIcon/></button>

    </div>,portal);

    
    

}


function DetailsBreadCrumbs({orderedCats}:{orderedCats:CategoryData[]}){


    return <>
    <a
    className="stencil-item"
            href={"product-list"}
            style={{fontSize:"14px",fontWeight:"600"}}>All Products</a>
            {orderedCats.length>0&& <span className="stencil-item" style={{fontSize:"14px",fontWeight:"600"}}>{"/"}</span> }
    
    {
        orderedCats.map((cat,index)=>{ 

            return <Fragment key={index}><a
            href={"product-list/"+cat.name.toLowerCase().replaceAll(" ","-").replaceAll("---","-").replaceAll("/","")}
            style={{fontSize:"14px",fontWeight:"600"}}>{cat.name}</a>
            {index<orderedCats.length-1&&<span style={{fontSize:"14px",fontWeight:"600"}}>{"/"}</span>}
            </Fragment>
         })
    }
    </>

}


export function  ShareDropDown ({ extraClass,shareTitle,shareURL,copyMessage }: { extraClass: string,shareTitle:string, shareURL:string,copyMessage?:string }) {

    const [isOpen, setIsOpen] = useState(false);
    const domRef = useRef<HTMLDivElement>(null);
    const encodedTitle = encodeURIComponent(shareTitle)
    const encodedUrl = encodeURIComponent(shareURL);
    const dopdownOptionStyling:any = {
  
        padding: " 10px 8px",
        width: "100%",
        textAlign: "left",
        display: "flex",
        alignItems: "center",
    }


    const clickOutside = (e: any) => {
        if (domRef.current && !domRef.current.contains(e.target)) {
            setIsOpen(false);
        }
    }

    useEffect(() => {
        document.addEventListener("mousedown", clickOutside);
        return () => {
            document.removeEventListener("mousedown", clickOutside);
        }

    })


    const openPopup = (e: any, link: string) => {
        e.preventDefault();
        window.open(link, 'popup', 'width=600,height=500');

    }


    return <div ref={domRef} className={extraClass} > 
    <button
    onClick={()=>setIsOpen(!isOpen)}
    className="invisible-button center-all  gray-hover"
    style={{border:"1px solid #33333333",borderRadius:"3px",width:"40px",height:"40px",color:"var(--default-font-color)",background:"none"}}
    ><ShareIcon/></button>
    {isOpen&&<>
    <div  style={{position:"absolute",width:"150px",right:"-5px",background:"white",color:"#333",borderRadius:"4px",padding:"4px 0px",
        boxShadow:"0px 2px 10px 0px rgba(0,0,0,.1)",zIndex:5
    }}
    
    
    className={"flex-column  align-start "}
    
    onClick={()=>{isOpen&&setIsOpen(false)}}
    >
        <a style={dopdownOptionStyling}  className="gray-hover no-a inherit-color" href={`https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`} onClick={(e) => { openPopup(e, `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`) }} rel="noreferrer" target="_blank"><FacebookIcon />&nbsp;&nbsp; Facebook</a>
        <a style={dopdownOptionStyling} className="gray-hover no-a inherit-color" href={`https://twitter.com/intent/tweet?text=${encodedTitle}&url=${encodedUrl}`} onClick={(e) => { openPopup(e, `https://twitter.com/intent/tweet?text=${encodedTitle}&url=${encodedUrl}`) }} rel="noreferrer" target="_blank"><TwitterIcon />&nbsp;&nbsp; X</a>
        <a style={dopdownOptionStyling} className="gray-hover no-a inherit-color" href={`http://pinterest.com/pin/create/link/?url=${encodedUrl}`} onClick={(e) => { openPopup(e, `http://pinterest.com/pin/create/link/?url=${encodedUrl}`) }} rel="noreferrer" target="_blank"><PintrestIcon />&nbsp;&nbsp; Pinterest</a>
        <button  style={dopdownOptionStyling} className="gray-hover white-bg invisible-button" onClick={(e)=>{
            navigator.clipboard.writeText(shareURL);
            Toast(copyMessage??"Copied to Clipboard")
        }} ><CopyLink/>&nbsp;&nbsp;Copy Link</button>
    </div>
    </>
    }
    </div>

}
